import type { TipoSolicitacao } from '../models';
import { MOTIVO_OUTRO, MOTIVOS_POR_TIPO_SOLICITACAO } from '../models';

interface MotivoSolicitacaoCamposProps {
  tipoSolicitacao: TipoSolicitacao;
  motivo: string;
  detalhe: string;
  onChangeMotivo: (motivo: string) => void;
  onChangeDetalhe: (detalhe: string) => void;
  disabled?: boolean;
}

/** Motivo (lista por tipo) + detalhe — detalhe obrigatório só em "Outro". Usado na abertura
 * (NovaSolicitacaoContent) e na edição pelo detalhe (MotivoSolicitacaoSection). */
export default function MotivoSolicitacaoCampos({
  tipoSolicitacao,
  motivo,
  detalhe,
  onChangeMotivo,
  onChangeDetalhe,
  disabled = false,
}: MotivoSolicitacaoCamposProps) {
  const opcoes = MOTIVOS_POR_TIPO_SOLICITACAO[tipoSolicitacao] ?? [];
  // Motivo antigo que saiu da lista continua aparecendo, pra não sumir ao editar.
  const opcoesComAtual = motivo && !opcoes.includes(motivo) ? [motivo, ...opcoes] : opcoes;

  return (
    <div className="space-y-2">
      <div>
        <label className="block text-sm font-medium text-gray-700">Motivo *</label>
        <select
          className="input-primary mt-1 w-full"
          value={motivo}
          onChange={(event) => onChangeMotivo(event.target.value)}
          disabled={disabled}
        >
          <option value="">Selecione</option>
          {opcoesComAtual.map((opcao) => (
            <option key={opcao} value={opcao}>
              {opcao}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Detalhe do motivo {motivo === MOTIVO_OUTRO ? '*' : '(opcional)'}
        </label>
        <input
          type="text"
          className="input-primary mt-1 w-full"
          maxLength={1000}
          placeholder={motivo === MOTIVO_OUTRO ? 'Descreva o motivo' : 'Ex.: tela piscando desde a semana passada'}
          value={detalhe}
          onChange={(event) => onChangeDetalhe(event.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
